import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

import {
  defineComponent,
  reactive,
  toRefs,
  computed,
  watch,
  ref,
  onMounted,
} from "vue";
import { stateList as states } from "@/core/listas/stateList";
import axios from "axios";


export default /*@__PURE__*/_defineComponent({
  __name: 'MunicipioUf',
  props: {
  modelValue: {
    type: [String, Number],
    required: false,
    default: "",
  },
  municipioLabel: {
    type: String,
    default: "Município",
  },
  municipioName: {
    type: Boolean,
    default: false,
  },
  ufLabel: {
    type: String,
    default: "UF",
  },
  isAvailableShow: {
    type: Boolean,
    default: true,
  },
  isAvailableShowMunicipio: {
    type: Boolean,
    default: true,
  },
  municipioClass: {
    type: String,
    default: "col-sm-4",
  },
  ufClass: {
    type: String,
    default: "col-sm-2",
  },
  currentUf: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: false,
  },
  requiredMunicipio: {
    type: Boolean,
    default: undefined,
  },
  isFilter: {
    type: Boolean,
    default: false,
  },
  disableMod: {
    type: Boolean,
    default: false,
  },
},
  emits: ["changeUf", "update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const data = reactive({
  municipios: [] as any,
  uf: "" as any,
  municipio: "" as any,
});

const { municipios, uf, municipio } = toRefs(data);

const municipioSelected = ref({ municipioId: "", municipioNome: "" });

const stateList = computed(() => {
  return states;
});

async function onChangeCarregarMunicipios(event) {
  const uf = event?.target?.value || event;
  emit("changeUf", data.uf);
  if (uf) {
    axios
      .get(
        process.env.VUE_APP_ORGANIZACAO_GEOGRAFICA_API +
          "/municipio/listagem/" +
          uf
      )
      .then((response) => {
        data.municipios = response.data.dados.map((dado) => {
          return {
            value: dado.id,
            label: dado.nome,
          };
        });
      })
      .catch((response) => (data.municipios = []));
  }
}

function onChange() {
  const municipioNome = (
    data.municipios.find((option) => option.value == data.municipio) || {}
  ).label;
  emit("getMunicipioNome", municipioNome);
  return emit("update:modelValue", data.municipio);
}

onMounted(async () => {
  if (props.currentUf) {
    data.uf = props.currentUf;
    onChangeCarregarMunicipios(props.currentUf);
  }

  if (props.modelValue) {
    data.municipio = props.modelValue;
  }
});

watch(
  () => props.currentUf,
  (value) => {
    if (value === "clearfilter") {
      data.uf = null;
      data.municipios = [];
      return;
    }
    if (value) {
      data.uf = value;
      onChangeCarregarMunicipios(value);
    }
  }
);

watch(
  () => props.modelValue,
  (modelValue) => {
    data.municipio = modelValue;
  }
);

watch(
  () => props.isAvailableShow,
  (value) => {
    if (!value) {
      data.municipio = "";
      data.uf = "";
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputSelect2 = _resolveComponent("InputSelect2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.isAvailableShow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(__props.ufClass)
        }, [
          _createVNode(_component_InputSelect, {
            label: `${__props.ufLabel}:`,
            name: "uf",
            modelValue: _unref(uf),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(uf) ? (uf).value = $event : null)),
            onChange: onChangeCarregarMunicipios,
            placeholder: "Selecione uma das opções",
            required: __props.required,
            options: stateList.value,
            disabled: __props.disableMod
          }, null, 8, ["label", "modelValue", "required", "options", "disabled"])
        ], 2))
      : _createCommentVNode("", true),
    (__props.isAvailableShow && __props.isAvailableShowMunicipio)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(__props.municipioClass)
        }, [
          (__props.municipioName)
            ? (_openBlock(), _createBlock(_component_InputSelect2, {
                key: 0,
                label: `${__props.municipioLabel}:`,
                name: "municipio_id",
                modelValue: _unref(municipio),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(municipio) ? (municipio).value = $event : null)),
                disabled: (__props.isFilter && !_unref(municipios).length) || __props.disableMod,
                onChange: _cache[2] || (_cache[2] = ($event: any) => (onChange())),
                placeholder: "Selecione uma das opções",
                required: __props.requiredMunicipio !== undefined ? __props.requiredMunicipio : __props.required,
                options: _unref(municipios)
              }, null, 8, ["label", "modelValue", "disabled", "required", "options"]))
            : (_openBlock(), _createBlock(_component_InputSelect, {
                key: 1,
                label: `${__props.municipioLabel}:`,
                name: "municipio_id",
                modelValue: _unref(municipio),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(municipio) ? (municipio).value = $event : null)),
                disabled: (__props.isFilter && !_unref(municipios).length) || __props.disableMod,
                onChange: _cache[4] || (_cache[4] = ($event: any) => (onChange())),
                placeholder: "Selecione uma das opções",
                required: __props.requiredMunicipio !== undefined ? __props.requiredMunicipio : __props.required,
                options: _unref(municipios)
              }, null, 8, ["label", "modelValue", "disabled", "required", "options"]))
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})